import { render } from "./match-details-modal-header.vue?vue&type=template&id=08d8533b&scoped=true&ts=true"
import script from "./match-details-modal-header.vue?vue&type=script&lang=ts"
export * from "./match-details-modal-header.vue?vue&type=script&lang=ts"

import "./match-details-modal-header.vue?vue&type=style&index=0&id=08d8533b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d8533b"]])

export default __exports__